<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="18">
          <div class="button-default">
            <div class="default-text">
              <span>Default destination for Buy Button unless user’s currency matches an additional currency specified below</span>
            </div>
            <div class="default-inputs">
              <div class="tab-button-item">
                <div class="item-col">
                  <span>If user’s currency is</span>
                  <el-select
                    class="item-select" size="mini" v-model="buttons.default.currency" filterable remote
                    placeholder="Currency" :remote-method="getCurrencies" :loading="loadingCurrencies"
                    @change="selectCurrency"
                  >
                    <el-option
                      v-for="(item) in currencies" :key="item._id" :value="item.currency"
                      :label="`${item.symbol} ${item.currency === item.symbol ? '' : `- ${item.currency}`}`"
                    ></el-option>
                  </el-select>
                </div>
                <div class="item-col">
                  <span>navigate user to</span>
                  <el-input class="item-input" size="mini" v-model.number="buttons.default.url" placeholder="https://www.enter-destination-here.com"></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="button-list">
            <TabButtonItem
              v-for="(item, index) in buttons.list" :key="index"
              :actionIndex="index" :actionItem="item" @handleUpdate="handleUpdate"
            />
            <el-button type="text" class="add-item" @click="addButtonItem">Add new Buy Button destination</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateInstance" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
import TabButtonItem from './TabButtonItem.vue'
import _ from 'lodash'
export default {
  name: 'TabBuyButton',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
    TabButtonItem
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    return {
      currencies: [],
      instance: {},
      buttons: {
        default: { currency: '$', url: '' },
        list: []
      },
      flagLoading,
      flagVisible,
      actionItems,
      loadingCurrencies: false
    }
  },
  created: function () {
    this.getCurrencies('')
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.buttons) this.buttons = { ...val.buttons }
        }
      },
      deep: true
    }
  },
  methods: {
    getCurrencies: function (query) {
      this.loadingCurrencies = true
      const url = `/api/v1/atk_player/currencies?page_num=1&page_size=40&is_deleted=false&name=${query}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.currencies = res.data.list
        } else {
          console.error('getCurrencies', res.msg)
        }
        that.loadingCurrencies = false
      }).catch(function (err) {
        that.loadingCurrencies = false
        console.error('getCurrencies', err)
      })
    },
    updateInstance: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instances/${this.instance._id}`
      const that = this
      const body = { buttons: this.buttons }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    handleUpdate: function (index, item) {
      this.buttons.list[index] = item
    },
    addButtonItem: function () {
      this.buttons.list.push({ currency: '', url: '' })
    },
    selectCurrency: function (val) {
      const index = _.findIndex(this.currencies, { currency: val })
      if (index > -1) {
        this.buttons.default.symbol = this.currencies[index].symbol
      }
    }
  }
}
</script>
<style scoped lang="scss">
.button-default {
  border: solid 1px #F2F2F2;
  padding: 15px;
  .default-inputs {
    margin-top: 20px;
  }
}
.tab-button-item {
  display: flex;
  align-items: center;
  .item-col {
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item-select {
      width: 128px;
      margin-left: 10px;
    }
    .item-input {
      width: 258px;
      margin-left: 10px;
    }
  }
}
.button-list {
  .add-item {
    margin-top: 20px;
  }
}
</style>
